<template>
    <div class="ClassStylePage2">
        <div class="newsbox" v-if="dataList.length!=0">
            <div class="leftImgRightTextBox">
                <div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                    <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                    <div class="contentbox">
                        <div class="title overflowone">{{item.pressTopic}}</div>
                        <div class="synopsis overflowtwo">{{item.synopsis}}</div>
                        <div class="time">{{item.pressTime | timer}}</div>
                    </div>
                </div>
            </div>
             <div class="pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                    :page-sizes="[4,6]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <div class="emptyBox" v-else>
            <img src="@/assets/imgs/home/emptyimg.png" />
            
        </div>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
    },
    data() {
        return {
            srcUrl: srcUrl,
            currentPage: 1,
            pageSize: 4,
            dataList: [],
            total: 0,
        }
    },
    created() {
        this.getNews()
    },
    methods: {
        async getNews() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                pressSuperClass: 36,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.dataList = data.result.list
                this.total = data.result.total;
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getNews();
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.getNews();
        },
        goNewsDetailFn(val) {
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        }

    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.ClassStylePage2 {
	 width: 1200px;
	.newsbox {
		.leftImgRightTextBox {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.itemBox {
				display: flex;
				flex-direction: row;
				margin: 0 48px 50px 0;
				width: 48%;
				cursor: pointer;
				&:nth-child(2n) {
					margin-right: 0;
				}
			}
		}
        max-height: 600px;
		min-height: 400px;
		position: relative;
		.pagination-box {
			position: absolute;
			bottom: -60px;
			left: 50%;
			transform: translateX(-50%);
			// margin: 0;
		}
	}
}
</style>


